/**
 * WeaponUnarmed — armored gauntlet / spiked knuckles.
 * No blade; shows a reinforced metal glove at the end of the right arm.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponUnarmed() {
  return (
    <g>
      {/* Gauntlet back-plate over right arm cuff */}
      <rect x="18.5" y="14.5" width="5"   height="2.5" rx="0.6" fill="#5a8abf" stroke="#7ab8f5" strokeWidth="0.5"/>
      {/* Knuckle spikes × 3 */}
      <rect x="19"   y="13"   width="0.9" height="2"   rx="0.3" fill="#9ab8cc"/>
      <rect x="20.7" y="12.5" width="0.9" height="2.5" rx="0.3" fill="#9ab8cc"/>
      <rect x="22.4" y="13"   width="0.9" height="2"   rx="0.3" fill="#9ab8cc"/>
    </g>
  );
}
